import {
  resolveCriteriaExecutors,
  resolveCriteriaWorkspaces,
} from '@/components/Gestores/gestorDashboardCriteriaUtils'

export type GestorDashboardFilterCriteria = {
  squadId?: number | null
  squadName?: string | null
  workspace?: string | null
  executor?: string | null
  workspaces?: string[] | null
  executors?: string[] | null
  taskType?: string | null
  search?: string | null
}

export type GestorDashboardFilterPreset = {
  id: string
  name: string
  isDefault: boolean
  sortOrder: number
  criteria: GestorDashboardFilterCriteria
  matchCount: number
  createdById: string
  createdByName: string
  createdAt: string
  updatedAt: string
}

export type GestorDashboardFilterCatalog = {
  squads: Array<{ id: number; label: string }>
  taskTypes: Array<{ id: number; label: string }>
}

export function presetCriteriaToFilters(criteria: GestorDashboardFilterCriteria) {
  return {
    squadId: criteria.squadId ?? null,
    squadName: criteria.squadName ?? '',
    workspaces: resolveCriteriaWorkspaces(criteria),
    executors: resolveCriteriaExecutors(criteria),
    taskType: criteria.taskType ?? '',
    search: criteria.search ?? '',
  }
}

export function filtersToPresetCriteria(input: {
  squadId: number | null
  squadName: string
  workspaces: string[]
  executors: string[]
  taskType: string
  search: string
}): GestorDashboardFilterCriteria {
  return {
    squadId: input.squadId,
    squadName: input.squadName || null,
    workspaces: input.workspaces.length > 0 ? input.workspaces : null,
    executors: input.executors.length > 0 ? input.executors : null,
    workspace: null,
    executor: null,
    taskType: input.taskType || null,
    search: input.search || null,
  }
}

export function hasAnyFilterCriteria(criteria: GestorDashboardFilterCriteria): boolean {
  return Boolean(
    criteria.squadId ||
      criteria.squadName ||
      resolveCriteriaWorkspaces(criteria).length > 0 ||
      resolveCriteriaExecutors(criteria).length > 0 ||
      criteria.taskType ||
      criteria.search,
  )
}
